module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="image-container">\n  <div class="image-box">\n    <img src="'+
((__t=( url ))==null?'':_.escape(__t))+
'" title="'+
((__t=( label ))==null?'':_.escape(__t))+
'" />\n  </div>\n  ';
 if(mode == "pick"){ 
__p+='\n  <a class="button button-secondary button-delete button-accept">\n    <img src="/static/images/icon-accept.png" />\n  </a>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./offers/templates/image-view.html
// module id = 295
// module chunks = 0